export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'cddb337d-11b1-4c8f-862b-2e4cfce3877e';
export const MODAL_CLOSE_SEC = 2.5;